import { useState, useMemo } from 'react';

import useCampsQuery from '../useCampsQuery';

export function useCurrentCampSelection(
  locationId: number,
  preselectedCampId?: number | null
) {
  const campsQuery = useCampsQuery(locationId);
  const [selectedCampId, setSelectedCampId] = useState<number | null>(
    preselectedCampId ?? null
  );

  const currentCampDetails = useMemo(
    () => campsQuery.data?.find((camp) => camp.id === selectedCampId),
    [campsQuery.data, selectedCampId]
  );

  return {
    isLoading: campsQuery.isLoading,
    data: campsQuery.data,
    selectedCampId,
    setSelectedCampId,
    currentCampDetails,
  };
}
